export class WinningPlan {
    amount: number;
    prices: WinningPlan.Price[] = [];
}

export module WinningPlan {
    export class Price {
        constructor(public hits: number, public odds: number) {
        }
    }
}


// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/shared/domain/winning-plan.ts